module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-35.342b7907.png";